module.exports = __webpack_public_path__ + "img/IMG_2458.cb5e32d5.jpeg";